module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Pin_16"],"path":[{"$":{"d":"M14.36,11a2,2,0,0,0-.72-1.5,4.26,4.26,0,0,0-1.65-1V2a3.45,3.45,0,0,0,1-.68A2.68,2.68,0,0,0,13.5,0H2.5A2.68,2.68,0,0,0,3,1.35,3.45,3.45,0,0,0,4,2V8.49a4.26,4.26,0,0,0-1.65,1A2,2,0,0,0,1.64,11H6.87L8,16l1.13-5Z","fill":"#464646"}}],"polygon":[{"$":{"points":"8.01 16 8 15.97 7.99 16 8.01 16","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Pin_16.svg
// module id = QcXY
// module chunks = 1